/* src/app/modules_v2/contacts/components/contact-expense-classification/contact-expense-classification.component.css */
.cec {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.cec-hint {
  margin: 0;
  color: var(--cf-text-muted, #6b7280);
  font-size: 0.85rem;
}
.cec-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}
.cec-warn {
  color: #b91c1c;
  font-size: 0.85rem;
}
.cec-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.cec-error {
  display: flex;
  align-items: center;
  gap: 12px;
}
/*# sourceMappingURL=contact-expense-classification.component.css.map */
